<div class="page-area cerrix-column">
    <div class="title-bar">
        <div class="title">{{ 'title' | t }}</div>
    </div>
    @if (ready) {
        <div class="button-bar">
            <button class="cerrix-button primary" (click)="toggleView()">
                <span>View as {{ showAsDiagram ? "table" : "diagram" }}</span
                ><i class="fal fa-{{ showAsDiagram ? 'table' : 'project-diagram' }}"></i>
            </button>
            @if (showAsDiagram) {
                <button class="cerrix-button secondary" (click)="exportDiagram()">
                    <span>{{ 'exportDiagram' | t }}</span><i class="fal fa-file-download"></i>
                </button>
            } @else {
                <button
                    class="cerrix-button secondary"
                    (click)="showTableReversed = !showTableReversed"
                >
                    <span>{{ 'reverseOrder' | t }}</span><i class="fal fa-sort-alt"></i>
                </button>
                <button class="cerrix-button secondary" (click)="exportTable()">
                    <span>{{ 'exportTable' | t }}</span><i class="fal fa-file-download"></i>
                </button>
            }
        </div>
    }
</div>

<!-- Because we need a reference to diagramContainer we only hide this element. -->
<div class="cerrix-workflow-history-graph" [hidden]="!showAsDiagram">
    <div class="centering-flex-blox">
        <div #diagramContainer></div>
    </div>
</div>
@if (!showAsDiagram) {
    <div class="cerrix-workflow-history-table" #tableContainer>
        <div class="cerrix-row header">
            <div>{{ 'columnStatus' | t }}</div>
            <div>{{ 'columnAction' | t }}</div>
            <div>{{ 'columnOn' | t }}</div>
            <div>{{ 'columnBy' | t }}</div>
            <ng-container [ngTemplateOutlet]="extraTableHeaders"></ng-container>
            <div>{{ 'columnComment' | t }}</div>
        </div>

        <div class="cerrix-column">
            @for (row of workflowHistory | reverse: showTableReversed; track row) {
                <div class="cerrix-row">
                    <div [title]="row.statusDescription">{{ row.statusDescription }}</div>
                    <div [title]="row.actionDescription">{{ row.actionDescription }}</div>
                    <div [title]="row.actionOn | dateTimeFormat">
                        {{ row.actionOn | dateTimeFormat }}
                    </div>
                    <div [title]="row.actionBy">{{ row.actionBy }}</div>
                    <ng-container
                        [ngTemplateOutlet]="extraTableValues"
                        [ngTemplateOutletContext]="{ row: row }"
                    ></ng-container>
                    <div [title]="row.comment">{{ row.comment }}</div>
                </div>
            }
        </div>
    </div>
}
